import { action, observable } from 'mobx'

class UI {
    @observable allPromptsOpen = false
    @observable promptsHidden = false

    @action
    toggleAllPromptsOpen = () => {
        this.allPromptsOpen = !this.allPromptsOpen
    }

    @action
    togglePrompts = () => {
        this.promptsHidden = !this.promptsHidden
    }
}

const ui = new UI()
window.ui = ui

export default ui



// WEBPACK FOOTER //
// ./src/stores/ui.js